import { render, staticRenderFns } from "./ReservationSpaceCard.vue?vue&type=template&id=80ed45ae"
import script from "./ReservationSpaceCard.vue?vue&type=script&lang=js"
export * from "./ReservationSpaceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports